module.exports = __webpack_public_path__ + "static/img/comment-outlined.d4d0a169.svg";